<template>
    <div class="availables__privates-box availables__privates-new ">
      <div v-for="(location, index) in setAmountAvailables" class="availables__privates" :key="index">
         <h2 class="availables__privates-title">{{location.name}}</h2>
         <div class="availables__privates-subtitle" @click="toRoute(location)">
           <div class="count">{{location.available}}</div>
           <div class="text">
             <h2>DISPONIBLE</h2>
           </div>
       </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "AvailablesPrivadas",
    props: ["setAmountAvailables","url","nivel"],
    methods:{
      toRoute(location){
        let nameNoSpace = location.name.replace(/ /g, "");
       if(this.nivel=="towerStageLevel"){
        this.$router.push({ path: `${this.url}/cve_nivel_te=${location.id}/nombre_nivel_te=${nameNoSpace}` })
       }else{
        this.$router.push({
            path: `/${this.url}/nombre_torre_etapa=${nameNoSpace}/cve_torre_etapa=${location.id}`,
            params: { torre: nameNoSpace, id: location.id }
        })
       }
         
      }
    }
  }
  </script>
  <style scoped>
  .availables__privates-new .availables__privates-subtitle{
    width: 170px;
    padding: 10px;
    background: #31af67;
    border-radius: 10px;
    margin: auto;
    cursor: pointer;
  }
  .availables__privates-new .count{
    background: white;
    color:#31af67;
  }
  .availables__privates-new .text{
    color:white;
  }
  </style>